import { ArrowRightOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import React from 'react';

interface Step1DepartmentProps {
  selectedDepartment: string;
  onSelect: (dept: string) => void;
  onNext: () => void;
  loading?: boolean;
}

const DEPARTMENTS = [
  'Finance',
  'Marketing',
  'Sales',
  'HR',
  'Operations',
  'Technology',
  'Leadership / Management',
  'Other',
];

const Step1Department: React.FC<Step1DepartmentProps> = ({
  selectedDepartment,
  onSelect,
  onNext,
  loading = false,
}) => {
  return (
    <div className='flex flex-col items-center text-center'>
      <h1 className='text-2xl md:text-3xl font-bold text-white tracking-tight mb-2'>
        Which department do you work in?
      </h1>
      <p className='text-sm text-grayZl-400 mb-8 max-w-md'>
        We will customize your learning track based on your field.
      </p>

      {/* Chips / Pills */}
      <div className='flex flex-wrap justify-center gap-3 max-w-xl mb-10'>
        {DEPARTMENTS.map((dept) => {
          const isSelected = selectedDepartment === dept;
          return (
            <button
              key={dept}
              type='button'
              onClick={() => onSelect(dept)}
              className={clsx(
                'group flex items-center gap-2.5 px-4 py-2.5 rounded-xl border text-sm font-medium transition-all duration-150 cursor-pointer active:scale-95',
                isSelected
                  ? 'bg-[#151515] border-[#FF5612] text-white shadow-[0_0_15px_rgba(255,86,18,0.2)]'
                  : 'bg-[#121212] border-[#262626] text-grayZl-200 hover:border-neutral-600 hover:bg-[#181818]',
              )}
            >
              {/* Radio dot indicator */}
              <div
                className={clsx(
                  'w-4 h-4 rounded-full border flex items-center justify-center transition-colors',
                  isSelected
                    ? 'border-[#FF5612]'
                    : 'border-grayZl-500 group-hover:border-grayZl-400',
                )}
              >
                {isSelected && (
                  <div className='w-2 h-2 rounded-full bg-[#FF5612]' />
                )}
              </div>
              <span>{dept}</span>
            </button>
          );
        })}
      </div>

      <p className='text-xs text-grayZl-400 mb-6'>
        You can always change your department settings later.
      </p>

      <button
        type='button'
        onClick={onNext}
        disabled={!selectedDepartment || loading}
        className='px-8 h-12 bg-[#FF5612] hover:bg-[#E54D10] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-xl text-sm transition-all duration-150 flex items-center justify-center gap-2 shadow-lg cursor-pointer active:scale-98'
      >
        <span>{loading ? 'Saving...' : 'Continue'}</span>
        <ArrowRightOutlined className='text-xs' />
      </button>
    </div>
  );
};

export default Step1Department;
